import axios from "axios";

// This web app is a client of the SHARED remote backend (same one the mobile app uses).
// The platform force-resets REACT_APP_BACKEND_URL to this app's preview host on every
// restart, which does NOT host the API — so we use a dedicated var with a fixed fallback.
const BACKEND_URL = process.env.REACT_APP_API_URL || "https://jobs-restaurant.emergent.host";
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "rj_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      const url = error.config?.url || "";
      // Don't nuke session on auth attempts themselves
      if (!url.includes("/auth/login") && !url.includes("/auth/register")) {
        localStorage.removeItem(TOKEN_KEY);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
